import {all, call, put, takeEvery} from '@redux-saga/core/effects';
import authApi from '../../@template/services/auth/authApi/authenticatedApi';
import {
    contentCategoryCreated,
    contentCategoryCreateError,
    localitiesError,
    localitiesLoaded,
    SETTINGS,
    settingsError,
    settingsLoaded,
    tagsUpdateFile,
    tagsUpdateFileSystem
} from './Actions';
import {coreApiConfig, filesApiConfig} from '../../config';
import {AxiosResponse} from 'axios';
import {parseErrorInfo} from '../../@template/helpers/errors';
import {Country} from '../../types/models/Country';
import {AdminUserSettings} from '../../types/views/AdminUserSettings';
import {ContentItemCategory} from "../../types/models/ContentItemCategory";

export function* LoadUserSession() {
    console.log('SAGA - sessionSaga - LoadUserSession');
    try {
        const res: AxiosResponse = yield authApi.get('/settings/admin');
        const sessionData: AdminUserSettings = AdminUserSettings.fromJS(res.data);
        yield put(settingsLoaded(sessionData));

        const fileRes: AxiosResponse = yield authApi.request({
            baseURL: filesApiConfig.Url,
            method: 'PUT',
            url: '/session'
        });
        const fileData = fileRes.data;
        yield put(tagsUpdateFile(fileData?.tagListModel?.fileTags?? []));
        yield put(tagsUpdateFileSystem(fileData?.tagListModel?.systemTags?? []));
    } catch (err) {
        yield put(settingsError(parseErrorInfo(err)));
    }
}

export function* LoadLocalities() {
    console.log('SAGA - sessionSaga - LoadLocalities');
    try {
        const res: AxiosResponse = yield authApi.get('/settings/localities');
        const countries: Country[] = [];
        res.data?.forEach((x: any) => {
            countries.push(new Country(x));
        });
        yield put(localitiesLoaded(countries));
    } catch (err) {
        yield put(localitiesError(parseErrorInfo(err)));
    }
}

export function* CreateContentCategory(newCategory: string) {
    console.log('SAGA - sessionSaga - Creating content category');
    try {
        const categoryRes: AxiosResponse = yield authApi.request({
            baseURL: coreApiConfig.Url,
            method: 'POST',
            url: '/content/categories'
        });
        const newCategoryObj = ContentItemCategory.fromJS(categoryRes.data);
        yield put(contentCategoryCreated(newCategoryObj));
    } catch (err) {
        yield put(contentCategoryCreateError(parseErrorInfo(err)));
    }
}

export function* watchLoadUserSession(){
    yield takeEvery(SETTINGS.LOAD, LoadUserSession)
}

export function* watchLoadLocalities(){
    yield takeEvery(SETTINGS.LOCALITIES_LOAD, LoadLocalities)
}

export default function* settings() {
    yield all ([
        call(watchLoadUserSession),
        call(watchLoadLocalities),
    ])
}